// extracted by mini-css-extract-plugin
module.exports = {"VideoPopup":"VideoPopup_VideoPopup__2XMEn"};